import { Component } from '@angular/core';

@Component({
  selector: 'ln-frame-svg-icon',
  imports: [],
  templateUrl: './frame-svg-icon.component.html',
  styleUrl: './frame-svg-icon.component.css',
})
export class FrameSvgIconComponent {}
